import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({ title, description, image, article }) => {
    const { pathname } = useLocation();

    // Valeurs par défaut
    const siteTitle = "Nyloria - Agence Web";
    const siteDescription =
        "Agence web spécialisée dans la création de sites web et applications modernes";
    const siteUrl = "https://nyloria.fr"; // Remplacez par votre URL
    const siteImage = `${siteUrl}/og-image.jpg`; // Image par défaut pour Open Graph

    const seo = {
        title: title ? `${title} | ${siteTitle}` : siteTitle,
        description: description || siteDescription,
        image: `${image || siteImage}`,
        url: `${siteUrl}${pathname}`,
    };

    return (
        <Helmet>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />

            {/* Facebook/Open Graph */}
            <meta property="og:url" content={seo.url} />
            {article ? (
                <meta property="og:type" content="article" />
            ) : (
                <meta property="og:type" content="website" />
            )}
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.image} />
            <meta property="og:locale" content="fr_FR" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />

            {/* Prerendering indicator for crawlers */}
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={seo.url} />
        </Helmet>
    );
};

export default SEO;
